import langmap from 'langmap';

export function getLocales() {
  const locales = [];
  const names: string[] = [];
  for (const locale in langmap) {
    const lang = langmap[locale];
    if (names.indexOf(lang.englishName) === -1) {
      locales.push({ value: locale, text: lang.nativeName });
    }
    names.push(lang.englishName);
  }
  return locales;
}
export function nativeName(locale: string) {
  const lang = langmap[locale];
  return lang?.nativeName;
}
